import { useContext, useSyncExternalStore } from 'react';

import { isDefined } from '@hsp/utilities';

import { TableContext } from 'components/table/context/table.context';
import { ITableContext } from 'types/components/table/context.type';

export const useTableStoreSelector = <SelectorOutput>(selector: (store: ITableContext) => SelectorOutput) => {
  const store = useContext(TableContext);

  if (!isDefined(store)) {
    throw new Error('Store not found');
  }

  return useSyncExternalStore(store.subscribe, () => selector(store.get()));
};
